// Module
var code = "<div style=\"margin:40px\"> <h1>Admin Dashboard Chart View - Internal Use Only</h1> <admin-overview-charts></admin-overview-charts> </div> ";
// Exports
module.exports = code;